export default "__VITE_ASSET__BjvFX9tw__ 800w, __VITE_ASSET__DRMH9Kpy__ 1280w, __VITE_ASSET__mlAiD8cT__ 1920w";